export default class PressReleasesFilter {
    static init() {
        if (document.querySelector(".listing-filter")) {
            this.initFilters();
        }
    }

    static initFilters() {
        document.getElementById('category-select')?.addEventListener('change', function () {
            if (this.value) {
                window.location.href = this.value;
            }
        });

        document.getElementById('year-select')?.addEventListener('change', function () {
            const selectedYear = this.value;
            let baseUrl = this.dataset.baseUrl || window.location.pathname;

            // Supprime toute pagination de type /page/x à la fin de l’URL
            baseUrl = baseUrl.replace(/\/page\/\d+\/?$/, '');

            const url = new URL(baseUrl, window.location.origin);

            if (selectedYear !== 'all') {
                url.searchParams.set('filter_year', selectedYear);
            } else {
                url.searchParams.delete('filter_year');
            }

            window.location.href = url.toString();
        });
    }
}
